<template>
    <div>
        <div class="row mb-3">
            <div class="col-12">
                <el-alert
                    v-if="showStatus"
                    :title="statusMessage"
                    :type="status ? 'success' : 'error'"
                    effect="dark"
                    style="width: 600px"
                ></el-alert>
            </div>
        </div>
        <div class="card shadow-lg rounded-card option-card white-card" style="max-width: 600px">
            <div class="card-body">
                <p class="text-black">
                    Verification token sent to this number
                    <strong>
                        +61 xxxxxx{{
                            applicant.phone ? applicant.phone.substring(applicant.phone.length - 3, applicant.phone.length) : ""
                        }}
                    </strong>
                    . The token is valid up to 15 minutes.
                </p>
                <div class="input-belt mt-3">
                    <label>Verification Token</label>
                    <input type="text" class="my-3" v-model="token" />
                    <el-row :gutter="20">
                        <el-col :span="12" :offset="0">
                            <el-button class="w-100" type="success" size="default" @click="verify">Verify</el-button>
                        </el-col>
                        <el-col :span="12" :offset="0">
                            <el-button class="w-100" type="primary" size="default" @click="resend">Resend Token</el-button>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ApplicationCard",
    props: {
        redirectLink: {
            required: false,
            type: [String, Boolean],
            default: false,
        },
        application: {
            type: Object,
            required: true,
        },
        loginUrl: {
            type: String,
            required: true,
        },
        resendUrl: {
            type: String,
            required: true,
        },
        applicant: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            token: null,
            status: null,
            showStatus: false,
            statusMessage: "",
            credentials: null,
        }
    },
    methods: {
        resend() {
            axios.post(this.resendUrl, {})
                .then(res => {
                    if (res.data) {
                        // update the warning message
                        this.showStatus = false
                        this.statusMessage = "Token Resent"
                        this.status = true
                        this.showStatus = true
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        verify() {
            axios.post(this.loginUrl, {token: this.token})
                .then(res => {
                    if (res.data) {
                        this.credentials = res.data
                        this.status = true
                        this.showStatus = false
                        this.statusMessage = "Verified"
                        if (this.redirectLink) {
                            location.href = `${this.redirectLink}`
                        } else {
                            this.$emit('userToken', res.data)
                        }
                    }
                })
                .catch(err => {
                    this.showStatus = true
                    this.statusMessage = "Verification Failed"
                    this.status = false
                    console.error(err)
                })
        },
    },
}
</script>
